import React from 'react';
import { Box, Typography, styled } from '@mui/material';

const Page404 = () => {
  return (
    <Container>
      <Typography variant="h1" color="error">
        404
      </Typography>
      <Typography variant="h5" sx={{ mt: 2 }}>
        Not Found
      </Typography>
      <Typography variant="body1" sx={{ mt: 1 }}>
        The page you are looking for does not exist.
      </Typography>
    </Container>
  );
};

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  textAlign: 'center'
});

export default Page404;
